import { render, staticRenderFns } from "./OptionItems.vue?vue&type=template&id=57c0c092&scoped=true"
import script from "./OptionItems.vue?vue&type=script&lang=js"
export * from "./OptionItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0c092",
  null
  
)

export default component.exports